import React, { useState, useEffect } from "react";
import Box from "../../components/Box";
import SidePopup from "../../components/Popup/SidePopup";
import "./Courses.css";
import WebLink from "../../components/WebLink";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import constant from "../../constant/constant";
import { logout } from "../../store/authSlice.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTitle } from "../../hooks/useTitle.js";
import { useParams } from "react-router-dom";

const Courses = () => {
  const user = useSelector((state) => state.auth);
  useTitle("Manage Profile - Flapone Aviation");
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();

  const [dataStatus, setDataStatus] = useState(false);
  const [courseData, setCourseData] = useState({});
  const [myRegcourse, setMyRegcourse] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [showCourseDetails, setShowCourseDetails] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showNumber, setShowNumber] = useState(false);
  let rmMobile=user.otherdata.student_rm_mobile;
  useEffect(() => {
    getCourseData();
  }, []);

  //=============code for api===================

  function getCourseData() {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_myaccount.php?fun=courseList`,
      headers: { "Auth-Id": user.auth_id },
      data: {},
    })
      .then(function (response) {
        checkUserLogin(response);

        if (response.data.data.status === "1") {
          if (response.data.data.courseDetails) {
            setMyRegcourse(response.data.data.myallcourses);
            setCourseData(response.data.data.courseDetails);
            setDataStatus(true);
          }
          setDataStatus(true);
        }
      })
      .catch(function (error) {
        //console.error('Error during login:', error);
      })
      .finally(() => {
        //setLoading(false);
      });
  }

  const [enquirCourseIds, setEnquirCourseIds] = useState([]);

  const enquiredCourse=()=>{
   toast.error("Enquiry already sent");
  }
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  function sendRmMailForSupport(){
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_myaccount.php?fun=supporttocallnow`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        course_id:selectedCourse.courseId,
        course_name:selectedCourse.courseName,
        location:constant.weburl+"my-account?tab=course",
      },
    })
      .then(function (response) {
        checkUserLogin(response);
      })
      .catch(function (error) {
        
      })
      .finally(() => {
        
      }); 
  }
  function enquireNowCourse(selectedCourse) {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_myaccount.php?fun=enquirecourse`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        course_id:selectedCourse.courseId,
        course_name:selectedCourse.courseName,
        location:constant.weburl+"my-account?tab=course",
      },
    })
      .then(function (response) {
        checkUserLogin(response);

        if(response.data.data.status === '1'){
            toast.success(response.data.data.msg);
            let newcourseIds = selectedCourse.courseId
            setEnquirCourseIds([...enquirCourseIds, newcourseIds]);
            if(response.data.data.paymentlink){
              window.open(response.data.data.paymentlink, '_blank');
            }
         }else if(response.data.data.status === '0'){
            toast.success(response.data.data.msg);
        }else{
            toast.success("Something went wrong");
        }
      })
      .catch(function (error) {
        //console.error('Error during login:', error);
      })
      .finally(() => {
        //setLoading(false);
      });
  }

/*  const handleViewAllClick = (course) => {
    setShowCourseDetails(true);
    setSelectedCourse(course);
  };
  */
  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const filteredCourses = (() => {
    if (!courseData || !courseData.categories) return [];
    if (selectedCategory === "All") {
      return courseData.categories.flatMap((category) => category.courses);
    } else {
      const category = courseData.categories.find(
        (cat) => cat.categoryName === selectedCategory
      );
      return category ? category.courses : [];
    }
  })();

  const activeCourses = (() => {
    if (!courseData || !courseData.categories) return [];
    return courseData.categories.flatMap((category) =>
      category.courses.filter((course) =>
        myRegcourse.active.includes(course.courseId)
      )
    );
  })();


  const newEnquireCourses = (() => {
    if (!courseData || !courseData.categories) return [];
    return courseData.categories.flatMap((category) =>
      category.courses.filter((course) =>
        myRegcourse.newenquire.includes(course.courseId)
      )
    );
  })();

  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };


 const handleViewAllClick = (course, flag) => {
	setShowCourseDetails(true);
	setSelectedCourse(course);
	if(flag == "1"){
		saveActivityLog(course);
	}
};

function saveActivityLog(selectedCourse) {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_myaccount.php?fun=saveActivityLog`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        course_id:selectedCourse.courseId
      },
    })
      .then(function (response) {
        checkUserLogin(response);
      })
  }

  return (
    <>
      {dataStatus && (
        <div className="course-container df mr20">
          <div className="w75">
            <div className="account-details df fdc">
              <div className="settings-head">
                <h3 className="fc3 fw5 fs18 mt12 mb24">
                  Courses
                  <div className="fs14 fc16 mt8 fw4 fc6 lh18">
                    Enroll in courses to advance your skills and become an
                    expert in drone and aircraft operations. Manage your
                    enrollments and track your progress here.
                  </div>
                </h3>
              </div>


              {newEnquireCourses && newEnquireCourses.length > 0 &&(
              <div className="active-courses mb24">
                <h3 className="fc3 fw5 fs18 mt12 mb24">Last Enquiry</h3>
                <div className="card-wrapper fww">
                  {newEnquireCourses.map((course, index) => (
                    <Box
                      className="card-info"
                      course={course}
                      key={index}
                      onViewAllClick={() => handleViewAllClick(course,1)}
                      currentCourse={myRegcourse.active}
                      completedCourse={myRegcourse.completed}
		      joinedCourse={myRegcourse.joined}
                      newEnquiryCourse={myRegcourse.newenquire}
                    />
                  ))}
                </div>
              </div>
              )}

              {/* Active Courses Section */}
            {activeCourses && activeCourses.length > 0 &&(
              <div className="active-courses mb24">
                <h3 className="fc3 fw5 fs18 mt12 mb24">Active Courses</h3>
                <div className="card-wrapper fww">
                  {activeCourses.map((course, index) => (
                    <Box
                      className="card-info bg6"
                      course={course}
                      key={index}
                      onViewAllClick={() => handleViewAllClick(course,0)}
                      currentCourse={myRegcourse.active}
                      completedCourse={myRegcourse.completed}
		       joinedCourse={myRegcourse.joined}
                      newEnquiryCourse={myRegcourse.newenquire}
                    />
                  ))}
                </div>
              </div>
              )}

              <div className="category-filter mb24 v-center fs14 ls1 lh18">
                <label className="radio-label cp">
                  <input
                    type="radio"
                    value="All"
                    checked={selectedCategory === "All"}
                    onChange={handleCategoryChange}
                    className="mr4"
                  />
                  All
                </label>
                {courseData &&
                  courseData.categories.map((category, index) => (
                    <label key={index} className="radio-label cp ml16 v-center">
                      <input
                        type="radio"
                        value={category.categoryName}
                        checked={selectedCategory === category.categoryName}
                        onChange={handleCategoryChange}
                        className="mr4"
                      />
                      {category.categoryName}
                    </label>
                  ))}
              </div>

              

              <div className="available-plans">
                <h3 className="fc3 fw5 fs18 mt12 mb24">Available Courses</h3>
                <div className="card-wrapper fww ">
                  {filteredCourses.map((course, index) => (
                    <Box
                      className="card-info"
                      course={course}
                      key={index}
                      onViewAllClick={() => handleViewAllClick(course,1)}
                      currentCourse={myRegcourse.active}
                      completedCourse={myRegcourse.completed}
                      joinedCourse={myRegcourse.joined}
                      newEnquiryCourse={myRegcourse.newenquire}
                    />
                  ))}
                </div>
              </div>

            </div>
          </div>
          {/* <WebLink link={"https://www.flapone.com/enquiry"}/> */}
          {showCourseDetails && (
            <SidePopup
              show={showCourseDetails}
              onClose={() => {
                setShowCourseDetails(false);
              }}
            >
              <div className="selected-plan-details">
                <div className="df jcsb profile-card-header brd-b1 p12 box-center bg4 w100 fc12 ls2 lh22">
                  <p className="fs18 fc3 ">{selectedCourse.courseName}</p>
                  <button
                    onClick={() => {
                      setShowCourseDetails(false);
                      document.body.style.overflow = "auto";
                    }}
                    className="lead-close-button"
                  >
                    X
                  </button>
                </div>
                <div className="pop-main">
                  <div className="course-details">
                    {selectedCourse.overviews.map((overview, index) => (
                      <div
                        className={`course-section bg4 mb24 ${overview.title
                          .toLowerCase()
                          .replace(/ /g, "-")}`}
                        key={index}
                      >
                        <h2>{overview.title}</h2>
                        <div
                          className="sub-overview"
                          dangerouslySetInnerHTML={{
                            __html: overview.overview,
                          }}
                        />
                      </div>
                    ))}
                    <div className="course-highlights bg4">
                      <h2>Course Highlights</h2>
                      <ul className="highlight-list">
                        {Object.keys(selectedCourse.courseHighlights).map(
                          (key, index) => (
                            <li
                              key={index}
                              className="profile-info-item df jcsb aic pt8 pb8 lh16"
                            >
                              <span>{key}</span>
                              {selectedCourse.courseHighlights[key]}
                            </li>
                          )
                        )}
                      </ul>
                    </div>
                    
                    <div className="course-price v-center jcc fdc">
                      <div className="price-container aic jcc">
                      {selectedCourse.coursePrice.INR.price &&(
                        <div className="v-center jcc courser-view-2">

                          {/* <div className="box-center fdc">
                            <p className="label fc8 fs14 ls1 lh18 mb4 fw6">
                              Course Fee
                            </p>
                            <p className="value fc6 fs16 ls1 lh18">
                              ₹{selectedCourse.coursePrice.INR.price}
                            </p>
                          </div>

                          <div className="box-center fdc ml12">
                            <p className="label fc8 fs18 ls1 lh18">+</p>
                          </div>
                          <div className="box-center fdc ml12">
                            <p className="label fc8 fs14 ls1 lh18 mb4 fw6">
                              GST (18%)
                            </p>
                            <p className="value fc6 fs16 ls1 lh18">
                              ₹{selectedCourse.coursePrice.INR.gstprice}
                            </p>
                          </div> */}
                          {/* <div className="box-center fdc ml12">
                            <p className="label fc8 fs18 ls1 lh18">=</p>
                          </div> */}
                          <div className="box-center fdc ml12">
                            <p className="label fc8 fs14 ls1 lh18 mb4 fw6">
                              Total Fee
                            </p>
                            <p className="value total-price fc3 ml4 fs20">
                              ₹{selectedCourse.coursePrice.INR.totalprice}
                            </p>
                          </div>
                        </div>
                      )}

                        <div className="v-center course-btn-2">
                            <>
                              {!myRegcourse.joined.includes(selectedCourse.courseId) &&  !myRegcourse.active.includes(selectedCourse.courseId) &&
                                !myRegcourse.completed.includes(selectedCourse.courseId) && selectedCourse.coursePrice.INR.price &&(
                                  <button
                                    type="button"
                                    className="btn-blue bg1 br24 fs14 cp pl16 pr16 pt10 pb10 fc1 ml32 ls2"
                                    onClick={() => {
                                      if (enquirCourseIds.includes(selectedCourse.courseId)) {
                                        enquiredCourse(selectedCourse);
                                      } else {
                                        enquireNowCourse(selectedCourse);
                                      }
                                    }}
                                  >
                                    Enroll Now
                                  </button>
                              )}
                            </>
                          
                          <div
                            type="button"
                            className="br24 fs14 cp pl16 pr16 pt10 pb10 fc3 ml16 ls2"
                            onClick={() => {
                              setShowNumber(!showNumber);
                              sendRmMailForSupport();
                            }}
                          >
                            <p>{showNumber ? "+91-"+rmMobile : "Call Now"}</p>
                          </div>{" "}
                        </div>
                      </div>
                      {/* <p className="price-sub-text fs14 fc6 mt12 ls1 lh18">
                        (including GST, Food &amp; Accommodation at the flying
                        location)
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </SidePopup>
          )}
          <ToastContainer position="bottom-right" />
        </div>
      )}
    </>
  );
};

export default Courses;
